var mySwiper1 = new Swiper(".mySwiper1", {
        slidesPerView: 1.5,
        centeredSlides: true,
        spaceBetween: 10,

        breakpoints:{
            720:{
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1024:{
                slidesPerView: 4,
            }
        },
        pagination: {
        el: ".swiper-pagination1",
        clickable: true,
        createElements:true,
    },
});

var customersComment = new Swiper(".customersComment", {
        slidesPerView: 1.5,
        centeredSlides: true,
        spaceBetween: 10,

        breakpoints:{
            720:{
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1024:{
                slidesPerView: 4,
            }
        },
        pagination: {
        el: ".customersPagination",
        clickable: true,
        createElements:true,
    },
});